var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-button",
        { attrs: { type: "primary" }, on: { click: _vm.showModal } },
        [_vm._v(" Open Modal with async logic ")]
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Title",
            visible: _vm.visible,
            "confirm-loading": _vm.confirmLoading,
            width: "1700",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [_c("edit-form")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }